<i class="material-icons {$$props.class || ''}" aria-hidden="true"><slot /></i>
